import { ArrowBack } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useQuery } from "react-query";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { findDashboard } from "../../../services/bi";
import { useStyles } from "../styles";
import { useCallback } from "react";
import { BiDetail } from "../../../types/bi";

export function BiDashboard() {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const styles = useStyles();
  const { state } = location as { state: BiDetail };

  const dashboard = useQuery({
    queryKey: ["dashboard", params.biId, params.dashboardId],
    queryFn: () => findDashboard(params.dashboardId),
    enabled: !state.url,
  });

  const handleNavigateGoToBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <div style={{ height: "70vh" }}>
      <div className={styles.root}>
        <Stack direction="row" spacing={1}>
          <Tooltip placement="top" title="Voltar">
            <IconButton onClick={handleNavigateGoToBack}>
              <ArrowBack />
            </IconButton>
          </Tooltip>
          <Typography variant="h4">{location.state["name"]}</Typography>
        </Stack>
      </div>
      {dashboard.isFetching ? (
        <Stack justifyContent="center" alignItems="center">
          <CircularProgress />
        </Stack>
      ) : (
        <iframe
          title={state.url ? state.url : dashboard.data}
          src={state.url ? state.url : dashboard.data}
          frameBorder="0"
          width="100%"
          height="150%"
        />
      )}
    </div>
  );
}
